import Form from "./components/Form";

function App() {
	return (
		<div className="App min-h-screen flex items-center justify-center px-3">
			<Form />
		</div>
	);
}

export default App;
